import {Token, ProtectedResponse, UserCredentials, RegisterResponse} from './types';

const API_URL = 'http://localhost:8000'; // Adjust for production later

export async function login({ email, password }: { email: string; password: string }): Promise<string> {
    const response = await fetch(`${API_URL}/auth/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            username: email,
            password,
        }).toString(),
    });

    if (!response.ok) {
        throw new Error('Login failed');
    }

    const data: Token = await response.json();
    localStorage.setItem('token', data.access_token);
    return data.access_token;
}

export async function register({ username, email, password }: UserCredentials): Promise<RegisterResponse> {
    const response = await fetch(`${API_URL}/auth/register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, email, password }),
    });

    if (!response.ok) {
        throw new Error('Registration failed');
    }

    return response.json();
}

export function logout(): void {
    localStorage.removeItem('token');
}

export function getToken(): string | null {
    return localStorage.getItem('token');
}

export async function fetchProtected(): Promise<ProtectedResponse> {
    const token = getToken();
    if (!token) {
        throw new Error('No token found');
    }

    const response = await fetch(`${API_URL}/auth/protected/`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to fetch protected data');
    }

    return response.json();
}